import { collection, where } from 'firebase/firestore';
import { firestore } from 'firebaseService/firebase';
import FirebaseFirestoreService from 'firebaseService/firebaseFirestore';

class AllianceServices extends FirebaseFirestoreService {
  static collectionPath = 'AllianceConfirm';
  static collection = collection(firestore, this.collectionPath);

  static async confirmAlliance(userUid) {
    try {
      const data = { userUid, confirm: true };
      const result = await this.addDoc(this.collection, data);
      return { success: true, result };
    } catch (error) {
      console.error(error);
      return { success: false, error };
    }
  }

  static async checkAlliancForUser(userUid) {
    try {
      const constraints = [where('isActive', '==', true), where('confirm', '==', true), where('userUid', '==', userUid)];
      const exists = await this.documentExists(this.collection, constraints);
      return { success: true, exists };
    } catch (error) {
      return { success: false, error };
    }
  }
}

export default AllianceServices;
